<template>
  <v-select
    name="producer_or_organization"
    class="custom-tailwind-select"
    v-model="producer_or_organization"
    :options="options"
  />
</template>

<script>
import vSelect from "vue-select";

export default {
  name: "ProducerOrOrganizationSelect",
  components: {
    vSelect
  },
  props: {
    default_producer_id: {
      default: null
    },
    default_organization_id: {
      default: null
    },
    options: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      producer_or_organization: null
    };
  },
  computed: {
    default_option: function () {
      return this.options.find(
        option =>
          option.producer_id == this.default_producer_id &&
          option.organization_id == this.default_organization_id
      );
    },

    producer_id: function () {
      return this.producer_or_organization?.producer_id;
    },
    organization_id: function () {
      return this.producer_or_organization?.organization_id;
    }
  },
  watch: {
    producer_id: function (producer_id) {
      this.$emit("update:producer_id", producer_id ?? null);
    },
    organization_id: function (organization_id) {
      this.$emit("update:organization_id", organization_id ?? null);
    }
  },
  methods: {
    setDefaultOption: function () {
      if (this.default_option)
        this.producer_or_organization = this.default_option;
    },
    setOptionsOne() {
      if (this.options.length == 1)
        this.producer_or_organization = this.options[0];
    }
  },
  mounted: function () {
    this.setDefaultOption();
    this.setOptionsOne();
  }
};
</script>
